/**
 * @owner @Appboy/whats-app
 */
import { z } from "zod";
import { whatsAppResponseMessageCommonSchema } from "@schemas/message/whatsAppResponseMessageCommonSchema";

// Refer to WhatsAppResponseMessageCtaUrlExport
export const whatsAppResponseCtaUrlMessageSchema = z.object({
  ...whatsAppResponseMessageCommonSchema.shape,
  layout: z.literal("cta-url"),
  header_text: z.string().nullable().optional(),
  body: z.string().nullable().optional(),
  footer: z.string().nullable().optional(),
  cta_url_button: z
    .object({
      display_text: z.string().nullable().optional(),
      url: z.string().nullable().optional(),
    })
    .optional(),
});
